/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";

export default function DataDeletionPage() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="data-deletion-page">
      {/* Header */}
      <header className="text-white" style={{ backgroundColor: "#00305E" }}>
        <div className="max-w-3xl mx-auto px-6 py-8 flex items-center gap-4">
          <img src="/logo_full.png" alt="SMARTIS Pro" className="h-12 w-auto rounded bg-white/10 p-1" />
          <div>
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Account &amp; Data Deletion</h1>
            <p className="text-white/70 text-sm mt-1">How to request deletion of your SMARTIS Pro account and data</p>
          </div>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-6 py-10">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 md:p-10 space-y-6">
          <div className="space-y-3 text-sm md:text-base leading-relaxed text-slate-700">
            <p>
              SMARTIS Pro accounts are <span className="font-semibold">created and managed by school administrators</span>.
              Individual staff members do not self-register, and student information is entered and controlled by
              authorized school personnel. Because of this, account and data deletion is handled through your school.
            </p>
          </div>

          <section data-testid="deletion-how-section">
            <h2 className="text-lg md:text-xl font-bold text-[#00305E] mb-3">How to request deletion</h2>
            <div className="space-y-3 text-sm md:text-base leading-relaxed text-slate-700">
              <p>You can request deletion of your account and associated data in either of these ways:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <span className="font-semibold">Contact your school administrator.</span> They manage user accounts
                  for your school and can remove your account and associated records.
                </li>
                <li>
                  <span className="font-semibold">Email us directly</span> at{" "}
                  <a href="mailto:admin@smartispro.com?subject=Account%20and%20Data%20Deletion%20Request" className="text-[#00305E] underline" data-testid="deletion-email-link">
                    admin@smartispro.com
                  </a>{" "}
                  with your name and the name of your school so we can route your request to the correct administrator.
                </li>
              </ul>
            </div>
          </section>

          <section data-testid="deletion-scope-section">
            <h2 className="text-lg md:text-xl font-bold text-[#00305E] mb-3">What gets deleted</h2>
            <div className="space-y-3 text-sm md:text-base leading-relaxed text-slate-700">
              <p>
                Upon a verified request, we delete the account's login credentials and personal profile information, and
                remove or return associated records as directed by the school. Certain information may be retained where
                required by law or a school's recordkeeping obligations, and student education records remain under the
                control of the contracting school or district as described in our{" "}
                <Link to="/privacy" className="text-[#00305E] underline" data-testid="deletion-privacy-link">Privacy Policy</Link>.
              </p>
            </div>
          </section>

          <section data-testid="deletion-contact-section">
            <h2 className="text-lg md:text-xl font-bold text-[#00305E] mb-3">Contact</h2>
            <div className="rounded-lg bg-slate-50 border border-slate-200 p-4 text-sm md:text-base text-slate-700">
              <p className="font-semibold text-slate-900">SMARTIS Pro Software</p>
              <p>801 Samson Rd. Swanton, VT 05488</p>
              <p>Email: <a href="mailto:admin@smartispro.com" className="text-[#00305E] underline">admin@smartispro.com</a></p>
              <p>Phone: <a href="tel:5704928463" className="text-[#00305E] underline">570-492-8463</a></p>
            </div>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/login" data-testid="deletion-back-link" className="text-[#00305E] font-medium hover:underline">
            ← Back to SMARTIS
          </Link>
        </div>
      </main>
    </div>
  );
}
